<form novalidate (ngSubmit)="save()" #formClientInfo="ngForm">
    <div class="card-body mt-0">
        <div class="row">
            <div class="col-lg-2 col-md-4 col-sm-12 mb-4 form-group">
                <label>
                    Pet #:
                </label>
                <input type="text" class="form-control form-control-sm" name="_pet_no" autocomplete="false" readonly
                    [(ngModel)]="petService.pet.pet_no" />
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12 mb-4 form-group">
                <label>Name:</label>
                <input type="text" class="form-control form-control-sm" name="_pet_name" autocomplete="false"
                    [(ngModel)]="petService.pet.pet_name" />
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12 mb-4 form-group">
                <label>Status:</label>
                <select class="form-control form-select-sm" name="_active" required [(ngModel)]="petService.pet.active" (change)="onStatusChange($event.target.value)">
                    <option value=""></option>
                    <option value="Y">Active</option>
                    <option value="N">Inactive</option>
                    <option value="D">Deceased</option>
                </select>
            </div>
            <div class="col-lg-5 col-md-4 col-sm-12 mb-4 form-group">
                <div class="col form-group">
                    <label class="form-label" (click)="sample()">Codes:</label>
                    <div style="display: flex;">
                        <div class="row">
    
                            <div class="col mb-4 d-flex align-items-center">
                                <div class="dropdown mr-1" *ngFor="let code of pet_codes; let i = index">
                                    <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" 
                                    [ngClass]="{'has-value': pet_codes[i]}"
                                    id="dropdownMenuButton{{i}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                      {{ pet_codes[i] || '_' }}
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-scrollable" aria-labelledby="dropdownMenuButton{{i}}">
                                        <a class="dropdown-item" (click)="onCodeChange('', i)">_</a>
                                        <a class="dropdown-item" *ngFor="let item of catalogService.pet_code" (click)="onCodeChange(item.code, i)">
                                            {{ item.code }} - {{ item.name }}
                                        </a>
                                    </div>
                                </div>  
     
                                <button type="button" class="btn btn-success btn-sm font-weight-bold" (click)="addCodes()" *ngIf="areAllCodesFilled()">
                                    <i class="las la-plus"></i>
                                </button> 
                            </div>
                             
                        </div> 
                    </div>
                </div>
            </div>
 
            <div class="col-lg-12 mb-4 separator separator-dashed"></div>
        </div> 
        <div class="row">
            <div class="col-lg-2 col-md-4 col-sm-12 mb-lg-0 mb-4 form-group">
                <label>Specie:</label>
                <select class="form-control form-select-sm" name="_specie" required [(ngModel)]="petService.pet.specie">
                    <option value=""></option>
                    <option *ngFor="let item of catalogService.specie" [value]="item.specie_index">
                        {{ item.specie_name }}
                    </option>
                </select>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12 mb-4 form-group">
                <label>
                    DOB:
                </label>
                <input type="date" class="form-control form-control-sm" name="_dob" autocomplete="false" required
                    [(ngModel)]="petService.pet.dob" (ngModelChange)="frecalculate()" />
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12 mb-4 form-group">
                <label>
                    Age:
                </label>
                <div class="input-group">
                    <input type="text" class="form-control form-control-sm" name="_age" autocomplete="false" disabled
                        [(ngModel)]="petService.pet.age" />
                    <div class="input-group-append">
                        <button class="btn btn-secondary btn-sm" type="button">Years</button>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12 mb-4 form-group">
                <label>
                    Sex:
                </label> 
                <div class="form-control form-control-sm">
                    <label class="mr-4">
                        <input type="radio" name="_sex" value="F" [(ngModel)]="petService.pet.sex"> Female
                    </label>
                    <label>
                        <input type="radio" name="_sex" value="M" [(ngModel)]="petService.pet.sex"> Male
                    </label>
                </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12 mb-4 form-group">
                <label>
                    Neutered:
                </label> 
                <div class="form-control form-control-sm">
                    <input type="checkbox" name="_neutered" >
                </div>
            </div>
            
        </div>
        <div class="row">
            <div class="col-lg-2 col-md-4 col-sm-12 mb-4 form-group">
                <label>
                    Breed:
                </label>
                <select class="form-control form-select-sm" name="_breed" required [(ngModel)]="petService.pet.breed">
                    <option value=""></option>
                    <option *ngFor="let item of catalogService.breed" [value]="item.breed_index">
                        {{ item.breed_name }}
                    </option>
                </select>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12 mb-4 form-group">
                <label>
                    Alt Breed:
                </label>
                <select class="form-control form-select-sm" name="_alt_breed" [(ngModel)]="petService.pet.alt_breed" >
                    <option value=""></option>
                    <option *ngFor="let item of catalogService.breed" [value]="item.breed_index">
                        {{ item.breed_name }}
                    </option>
                </select>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12 mb-4 form-group">
                <label>
                    Color:
                </label>
                <select class="form-control form-select-sm" name="_color" required [(ngModel)]="petService.pet.color">
                    <option value=""></option>
                    <option *ngFor="let item of catalogService.color" [value]="item.color_index">
                        {{ item.color_name }}
                    </option>
                </select>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12 mb-4 form-group">
                <label>
                  Alt Color:
                </label>
                <select class="form-control form-select-sm" name="_alt_color" [(ngModel)]="petService.pet.alt_color" >
                    <option value=""></option>
                    <option *ngFor="let item of catalogService.color" [value]="item.color_index">
                        {{ item.color_name }}
                    </option>
                </select>
            </div>
            <div class="col-lg-1 col-md-4 col-sm-12 mb-4 form-group">
                <label>
                    Weight:
                </label>
                <input type="number" class="form-control form-control-sm" name="_weight" autocomplete="false" required
                    [(ngModel)]="petService.pet.weight" />
            </div>
            <div class="col-lg-1 col-md-4 col-sm-12 mb-4 form-group">
                <label>
                    Height:
                </label>
                <input type="number" class="form-control form-control-sm" name="_height" autocomplete="false" required
                    [(ngModel)]="petService.pet.height" />
            </div> 
            <div class="col-lg-1 col-md-4 col-sm-12 mb-4 form-group">
                <label>
                    Temperature:
                </label>
                <input type="number" class="form-control form-control-sm" name="_temperature" autocomplete="false" required
                    [(ngModel)]="petService.pet.temperature" />
            </div> 
        </div>
        <div class="row">
            
        </div>
    </div>
    <div class="card-footer text-right py-4">

        <button type="submit" class="btn btn-primary" [disabled]="formClientInfo.invalid">
            Save Changes
        </button>
    </div>
</form>

<style>
    code-style{
        padding: 0.1rem .1rem !important; text-align: center !important; width: 3em !important;
    } 
    .dropdown-menu-scrollable {
        max-height: 200px; /* Adjust the height as needed */
        overflow-y: auto;
    }
    .has-value {
        background-color: #ADD8E6 !important;
    }
</style>